import { render, staticRenderFns } from "./investorLogin.vue?vue&type=template&id=2ba6b4ed&scoped=true"
import script from "./investorLogin.vue?vue&type=script&lang=js"
export * from "./investorLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6b4ed",
  null
  
)

export default component.exports